/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PalAuthSubmission } from './PalAuthSubmission';
import {
    PalAuthSubmissionFromJSON,
    PalAuthSubmissionFromJSONTyped,
    PalAuthSubmissionToJSON,
} from './PalAuthSubmission';
import type { PalAuthorizationLead } from './PalAuthorizationLead';
import {
    PalAuthorizationLeadFromJSON,
    PalAuthorizationLeadFromJSONTyped,
    PalAuthorizationLeadToJSON,
} from './PalAuthorizationLead';

/**
 * 
 * @export
 * @interface PalAuthorization
 */
export interface PalAuthorization {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorization
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorization
     */
    lead_id: string;
    /**
     * 
     * @type {PalAuthorizationLead}
     * @memberof PalAuthorization
     */
    lead?: PalAuthorizationLead;
    /**
     * 
     * @type {Array<PalAuthSubmission>}
     * @memberof PalAuthorization
     */
    submissions?: Array<PalAuthSubmission>;
}

/**
 * Check if a given object implements the PalAuthorization interface.
 */
export function instanceOfPalAuthorization(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "lead_id" in value;

    return isInstance;
}

export function PalAuthorizationFromJSON(json: any): PalAuthorization {
    return PalAuthorizationFromJSONTyped(json, false);
}

export function PalAuthorizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorization {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'lead': !exists(json, 'lead') ? undefined : PalAuthorizationLeadFromJSON(json['lead']),
        'submissions': !exists(json, 'submissions') ? undefined : ((json['submissions'] as Array<any>).map(PalAuthSubmissionFromJSON)),
    };
}

export function PalAuthorizationToJSON(value?: PalAuthorization | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'lead': PalAuthorizationLeadToJSON(value.lead),
        'submissions': value.submissions === undefined ? undefined : ((value.submissions as Array<any>).map(PalAuthSubmissionToJSON)),
    };
}

